import { useNavigate } from 'react-router';
import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../store/store';
import { Button, Tooltip } from '@material-tailwind/react';
import { FriendItem } from '../../components/item/FriendItem';
import { ProfilePane } from '../../components/inbox/ProfilePane';
import { useParams } from 'react-router-dom';

const ChannelLayout = observer(() => {
  const store = useStore();
  const navigate = useNavigate();
  const { server, channel } = useParams();
  const channelId = channel ? Number(channel) : undefined;

  React.useEffect(() => {
    if (!channelId) return;
    const ch = store.channels.getChannel(channelId);
    if (ch) {
      store.channels.setActiveChannel(ch);
    } else {
      store.channels.loadChannel(channelId).catch(() => {
        // Handle error silently
      });
    }
  }, [channelId]);

  const currentChannel = channelId ? store.channels.getChannel(channelId) : null;

  return (
    <>
      <div>{server}</div>
      <div>{channel}</div>
      <div className={'whitespace-pre-wrap'}>{JSON.stringify(currentChannel, null, 2)}</div>
    </>
  );
});

export default ChannelLayout;
